import React, { useState } from 'react';
import { Card, Button, Typography, Box, AppBar, Toolbar, IconButton, CircularProgress } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function LabConsolleRelaunchPage(props) {
    const { labProps } = props;
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [status, setStatus] = useState(null);

    const handleBack = () => {
        props.setIsShowRelaunchLab(false);
    };

    const handleConfirm = async () => {
        setIsSubmitting(true);
        setStatus(null);
        try {
            const url = process.env.REACT_APP_URL_RETRY_LAST_COMMAND;
            const payload = { idLab: labProps.idLab };
            const formBody = [];
            formBody.push("payload=" + encodeURIComponent(JSON.stringify(payload)));

            const response = await fetch(url, {
                credentials: 'include',
                method: "POST",
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: formBody
            });
            const data = await response.json();
            setStatus(data?.status || 'OK');
        } catch (e) {
            setStatus('Errore');
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!labProps) {
        return (
            <AppBar position="sticky" color="default" elevation={1} sx={{ backgroundColor: '#fff' }}>
                <Toolbar>
                    <IconButton edge="start" onClick={() => props.setIsShowRelaunchLab(false)}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#a71e3b' }}>
                        Rilancio Comando
                    </Typography>
                </Toolbar>
            </AppBar>
        );
    }

    return (
        <React.Fragment>
            <AppBar position="sticky" color="default" elevation={1} sx={{ backgroundColor: '#fff' }}>
                <Toolbar sx={{ gap: 2 }}>
                    <IconButton edge="start" onClick={handleBack} disabled={isSubmitting}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography variant="h6" noWrap sx={{ fontWeight: 'bold', color: '#a71e3b' }}>
                            Rilancio Comando
                        </Typography>
                        <Typography variant="body2" color="textSecondary" noWrap>
                            {labProps.labName} &mdash; {labProps.baseImage?.name} ({labProps.labType})
                        </Typography>
                    </Box>
                </Toolbar>
            </AppBar>

            <Box sx={{ p: 3 }}>
                <Card sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'flex-start' }}>
                    <Typography variant="body1">
                        Vuoi rilanciare il comando per questo laboratorio?
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={isSubmitting || status === 'OK'}
                            onClick={handleConfirm}
                        >
                            {isSubmitting ? <CircularProgress size={24} /> : 'Conferma'}
                        </Button>
                    </Box>
                    {status && (
                        <Typography variant="body2" color={status === 'OK' ? 'success.main' : 'error'}>
                            {status === 'OK' ? 'Comando rilanciato con successo.' : 'Errore nel rilancio comando.'}
                        </Typography>
                    )}
                </Card>
            </Box>
        </React.Fragment>
    );
}

export default LabConsolleRelaunchPage;
